import { render, staticRenderFns } from "./payment-error-modal.vue?vue&type=template&id=54077b16&"
import script from "./payment-error-modal.vue?vue&type=script&lang=js&"
export * from "./payment-error-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports